<template>
  <div class="fund-section">
    <div class="asset-section">
      <div class="section-header">
        <span class="section-title">{{ $t("asset.asset") }}</span>
      </div>
      <div class="asset-list" v-if="assets.length > 0">
        <div
          class="asset-card"
          v-for="(item, index) in assets"
          :key="index"
          @click="$emit('select-asset', item)"
        >
          <div class="asset-info">
            <div class="asset-icon">
              <img
                v-if="item.icon"
                :src="item.icon"
                class="icon-image"
                @error="onIconError(item)"
              />
              <span v-else class="icon-text">{{
                item.assetType && item.assetType.charAt(0)
              }}</span>
            </div>
            <span class="asset-name">{{
              item.assetType === "USDT" ? $t("asset.usd") : item.assetType
            }}</span>
          </div>
          <div class="asset-right">
            <div class="asset-value">
              <span class="value-amount">{{ formatBalance(item) }}</span>
            </div>
            <span class="exchange-rate">{{ formatBalance(item) }} ≈ {{ formatCurrency(item) }} {{ item.currency === "USD" ? $t("asset.us_dollar") : $t("asset.hk_dollar") }}</span>
          </div>
        </div>
        <div class="load-more">
          <span class="load-more-text">{{ $t("asset.loaded_all") }}</span>
        </div>
      </div>
      <div v-else class="no-data">
        <span class="no-data-text">{{ $t("asset.no_data") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import precisionMixin from "@/mixins/precisionMixin";
export default {
  name: "FundSection",
  mixins: [precisionMixin],
  props: {
    assets: {
      type: Array,
      required: true,
    },
  },
  emits: ["select-asset"],
  methods: {
    onIconError(item) {
      item.icon = null;
    },
    formatBalance(item) {
      const symbol = `${item.assetType}/${item.currency || 'USDT'}`;
      const precision = this.getSymbolPrecision(symbol, 'coin');
      return Number(item.balanceAvailable || 0).toFixed(precision);
    },
    formatCurrency(item) {
      return Number(item.assetCurrency || 0).toFixed(2);
    },
  },
};
</script>

<style lang="less" scoped>
.fund-section {
  .asset-section {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 32px;

    .section-header {
      display: flex;
      align-items: flex-end;
      margin-bottom: 24px;
      border-bottom: 1px solid #e2e3e3;

      .section-title {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 8px;
        position: relative;
        display: inline-block;
      }
      .section-title::before {
        content: "";
        display: inline-block;
        width: 100%;
        height: 2px;
        position: absolute;
        bottom: -8px;
        left: 0;
        background-color: #4063ff;
      }
    }
  }

  .asset-list {
    .asset-card:hover {
      background-color: rgba(225, 234, 255, 0.6);
    }
    .asset-card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 24px;
      cursor: pointer;
      border-radius: 12px;
      transition: background-color 0.2s;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      .asset-info {
        display: flex;
        align-items: center;

        .asset-icon {
          width: 40px;
          height: 40px;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          border-radius: 8px;
          overflow: hidden;

          .icon-image {
            width: 40px;
            height: 40px;
            object-fit: cover;
          }

          .icon-text {
            font-size: 16px;
            font-weight: 600;
            color: #333333;
          }
        }

        .asset-name {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
        }
      }

      .asset-right {
        display: flex;
        flex-flow: column;
        align-items: flex-end;

        .asset-value {
          display: flex;
          align-items: center;
          gap: 8px;

          .value-amount {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
          }

          .value-currency {
            font-size: 18px;
            color: #333333;
          }

          i {
            font-size: 18px;
            color: #333333;
          }
        }

        .exchange-rate {
          font-size: 12px;
          color: #999999;
          white-space: nowrap;
        }
      }

      .arrow-icon {
        font-size: 24px;
        color: #cccccc;
        margin-left: 12px;
        flex-shrink: 0;
      }
    }

    .load-more {
      padding: 24px 0;
      text-align: center;

      .load-more-text {
        font-size: 14px;
        color: #999999;
      }
    }
  }

  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;

    .no-data-text {
      font-size: 16px;
      color: #999999;
    }
  }
}
</style>